import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { SwitchButton } from "../SwitchButton";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { SplashState } from "../SplashState";

export class SettingsLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "settings-layer");

        const backgroundImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "bg.png");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.set(2, 2 * GameVars.scaleY);
        backgroundImage.inputEnabled = true;
        backgroundImage.events.onInputDown.add(this.onClickBackground, this);
        this.add(backgroundImage);

        const tab = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "menu_tab.png");
        tab.scale.y = GameVars.scaleY;
        this.add(tab);

        const buttonHome = new Phaser.Button(this.game, 45, 45 * GameVars.scaleY, "texture_atlas_1", this.onClickHome, this);
        buttonHome.setFrames("button_home_on.png", "button_home_off.png", "button_home_on.png");
        buttonHome.forceOut = true;
        buttonHome.anchor.set(.5);
        buttonHome.scale.y = GameVars.scaleY;
        this.add(buttonHome);

        const titleLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 15 * GameVars.scaleY, GameVars.texts[GameVars.language]["SETTINGS"], { font: "52px Roboto Slab Regular", fill: "#1b2d3d", align: "center"}); 
        titleLabel.scale.y = GameVars.scaleY;
        titleLabel.anchor.x = .5;
        this.add(titleLabel);

        const buttonsContainer = new Phaser.Group(this.game);
        buttonsContainer.x = GameConstants.GAME_WIDTH / 2;
        buttonsContainer.y = 370;
        buttonsContainer.scale.y = GameVars.scaleY;
        this.add(buttonsContainer);

        const soundFXLabel = new Phaser.Text(this.game, -85, 0, GameVars.texts[GameVars.language]["SOUND FX"], { font: "46px Roboto Slab Regular", fill: "#FFFFFF", align: "center"}); 
        soundFXLabel.anchor.x = .5;
        buttonsContainer.add(soundFXLabel);

        const timerLabel = new Phaser.Text(this.game, soundFXLabel.x, soundFXLabel.y + 90 , GameVars.texts[GameVars.language]["TIMER"], { font: "46px Roboto Slab Regular", fill: "#FFFFFF", align: "center"}); 
        timerLabel.anchor.x = .5;
        buttonsContainer.add(timerLabel);

        const audioSwitchButton = new SwitchButton(this.game, !AudioManager.isMuted, "switch_on.png", "switch_off.png", this);
        audioSwitchButton.x = 85;
        audioSwitchButton.y = -4;
        audioSwitchButton.name = GameConstants.AUDIO_KEY;
        buttonsContainer.add(audioSwitchButton);

        const timerSwitchButton = new SwitchButton(this.game, GameVars.isTimerOn, "switch_on.png", "switch_off.png", this);
        timerSwitchButton.x = audioSwitchButton.x;
        timerSwitchButton.y = audioSwitchButton.y + 100;
        timerSwitchButton.name = GameConstants.TIMER_SWITCH;
        buttonsContainer.add(timerSwitchButton);
    }

    public switched(switchButton: SwitchButton): void {

        if (switchButton.name === GameConstants.AUDIO_KEY) {
            
            if (switchButton.isOn) {
                AudioManager.unmute(true);
            } else {
                AudioManager.mute(true);
            }

        } else {
            if (switchButton.isOn) {
                GameManager.changeTimerPreferences(true, true);
            } else {
                GameManager.changeTimerPreferences(false, true);
            }
        }
    }
    
    private onClickHome(b: Phaser.Button): void {

        b.clearFrames();

        SplashState.currentInstance.removeSettingsLayer();

        AudioManager.playSound("click"); 
    }

    private onClickBackground(): void {
        //
    }
}
